import { render, staticRenderFns } from "./workProtectiveGear.vue?vue&type=template&id=f5ac1f16"
import script from "./workProtectiveGear.vue?vue&type=script&lang=js"
export * from "./workProtectiveGear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ac1f16')) {
      api.createRecord('f5ac1f16', component.options)
    } else {
      api.reload('f5ac1f16', component.options)
    }
    module.hot.accept("./workProtectiveGear.vue?vue&type=template&id=f5ac1f16", function () {
      api.rerender('f5ac1f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/base/workProtectiveGear.vue"
export default component.exports